import useStore from '@/stores/store';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import produce from 'immer';
import { replacePostInCache } from './feed.actions';
import { authorizedServerFetch } from './server.actions';
import { sumBy } from 'lodash-es';
import { uploadImage } from '@/stores/userActions';
import { fetchViaProxy } from './proxy-fetch';

export const useMakeInKindDonation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['make-inkind-donation'],
    mutationFn: async ({ campaignId, donations }) => {
      const options = {
        method: 'POST',
        body: JSON.stringify(donations),
      };

      const path = `campaigns/${campaignId}/donation`;

      const { ok, data } = await authorizedServerFetch(path, options);

      if (!ok || !data) {
        throw new Error(`Error submitting in-kind donation pledge`);
      }

      return data;
    },
    onSuccess: (serverData, { donations }) => {
      // TODO - Shyam handle reward
      const { post } = serverData;

      replacePostInCache(post, queryClient);
      // update donated goods count
      const numItems = sumBy(donations.goods, 'quantity');
      useStore.setState(
        produce((draft) => {
          draft.user.profile.goodsDonated += numItems;
        }),
      );
    },
  });
};

export const confirmInKindDelivery = async (
  donationId,
  deliveryMode,
  imageFile,
) => {
  const imageUrl = imageFile
    ? await uploadImage(imageFile, 'donation-receipts')
    : null;
  const path = `/proxy/v1/users/me/in-kind-donations/${donationId}/delivery`;
  return fetchViaProxy(path, {
    method: 'POST',
    body: JSON.stringify({
      deliveryMethod: deliveryMode,
      deliveryReceiptUrl: imageUrl,
    }),
  });
};
